import { render, staticRenderFns } from "./TicketTemplateList.vue?vue&type=template&id=3fc864e3&"
import script from "./TicketTemplateList.vue?vue&type=script&lang=js&"
export * from "./TicketTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports